/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-11-25 12:26:02
 * @LastEditTime: 2026-07-06
 * @Description: App shell with multilingual SEO route basename support
 */
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollToTop from './ScrollToTop';
import { useRegionLanguage } from './hooks/useRegionLanguage';
import SeoManager from './components/seo/SeoManager';
import { getRouterBasename } from './utils/languageRouting';
import LiveChatWidget from './components/integrations/LiveChatWidget';
import DocumentLanguage from './components/i18n/DocumentLanguage';

function App() {
  useRegionLanguage();

  const routerBasename = getRouterBasename(
    __BASE_PATH__,
    typeof window !== 'undefined' ? window.location.pathname : '/',
  );

  return (
    <BrowserRouter basename={routerBasename}>
      <SeoManager />
      <DocumentLanguage />
      <LiveChatWidget />
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
